function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#141318",
  fillRule: "evenodd",
  d: "M15.972 2.667c-7.348 0-13.305 6.07-13.305 13.106 0 7.49 5.957 13.56 13.305 13.56 7.404 0 13.361-6.07 13.361-13.56 0-7.035-5.957-13.106-13.36-13.106zm6.158 10.466c0 4.444-3.117 9.534-9.212 9.534-1.801 0-3.671-.646-4.918-1.29h.623c1.247 0 3.048-.646 4.295-1.22-1.801 0-3.048-1.29-3.048-2.58H11.117c-1.247-.645-2.494-1.864-2.494-3.154H9.87c-.623-.645-1.247-1.29-1.247-2.509 0-.645 0-1.29.624-1.935 1.247 1.935 3.67 3.799 6.095 3.799v-.645c0-1.864 1.87-3.8 3.671-3.8.623 0 1.87.646 1.87 1.29 1.247 0 1.87-.644 2.494-.644-.624.645-.624 1.29-1.247 1.935.623 0 1.247-.645 1.87-.645-.623.645-1.247 1.29-1.87 1.864z"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.99c137c4.svg";
export { ForwardRef as ReactComponent };